import { render, staticRenderFns } from "./xxtd.vue?vue&type=template&id=788904ce&scoped=true&"
var script = {}
import style0 from "./xxtd.vue?vue&type=style&index=0&id=788904ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788904ce",
  null
  
)

export default component.exports